import {Component, Input, OnInit} from '@angular/core';
import moment from 'moment';
@Component({
  selector: 'app-late-delivery',
  templateUrl: './late-delivery.component.html',
  styleUrls: ['./late-delivery.component.scss']
})
export class LateDeliveryComponent implements OnInit {
  moment = moment;
  @Input() delivery;
  constructor() { }

  ngOnInit(): void {
  }

}
